export default "SELECT *\nFROM sys.yb_describe($(target), true, false)\n"